import { useState, useEffect } from 'react'
import { getEmployerzoneData } from './../../../../../api'

function EmployerZone() {
  const [allJobData, setAllJobData] = useState([])
  useEffect(async () => {
    const response = await getEmployerzoneData();

    setAllJobData(response.data.jobs.filter(job => job.typeOfJob === "Employer_Zone"))
  }, [])

  const handleDelete = async (event, jobId) => {
    event.preventDefault()
    event.target.disabled = true

    const { data } = await getEmployerzoneData(jobId)
    if (data.success && allJobData) {
      const newJobData = allJobData.filter(job => job._id !== data.job._id)
      setAllJobData(newJobData)
      event.target.disabled = false
    } else {
      // Send Error Message
      event.target.disabled = false
    }

  }

  const handleEdit = async (jobId, jobData) => {
    // const { data } = await editJob(jobId, jobData)
    // console.log("Edited Data:", data)
    // openForm({ jobData })
  }

  return (
    <>
      <h2>Posted Jobs</h2>
      <div className="table__container">
        <table className="table">
          <tr className="table__header">
            <th>Job ID</th>
            <th>Name</th>
            <th>Company Name</th>
            <th>Contact Number</th>
            <th>Email</th>
            <th>Description</th>
            <th>Delete</th>
          </tr>
          {allJobData ? allJobData.map((data, index) => {
            return (
              <tr className="table__row" key={index}>
                <td>{data._id}</td>
                <td>{data.name}</td>
                <td>{data.company}</td>
                <td className="width-min">{data.contact}</td>
                <td>{data.email}</td>
                <td>{data.desc}</td>
                <td><button onClick={(e) => handleDelete(e, data._id)}>delete</button></td>
                {/* <td>{null}</td> */}
              </tr>
            )
          }) : <></>}
        </table>
      </div>
    </>
  )
}

export default EmployerZone